import ExpandableList from "../common/ExpandableList";
import TowingPlane, {TowingPlaneForm} from "./TowingPlane";
import {REST_TOWINGPLANE_URL} from "../common/constants";

export const TowingPlaneList = ExpandableList(TowingPlane, TowingPlaneForm, REST_TOWINGPLANE_URL, "towingplane", "Seznam vlečných", "Nová vlečná", "Přidat vlečnou");

